(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Calculator", [], factory);
	else if(typeof exports === 'object')
		exports["Calculator"] = factory();
	else
		root["Calculator"] = factory();
})(window, function() {
return 